import type { Route } from '../admin-fetch';
import { callServer } from '../server';
import { toResponse } from '../respond';

// Global search across users, groups and expenses — run by the server.
export const searchRoutes: Route[] = [
  ['GET', '/api/search', async (req) => {
    const q = new URL(req.url).searchParams.get('q') ?? '';
    return toResponse(await callServer('GET', `/api/v1/admin/search?q=${encodeURIComponent(q)}`), 'results');
  }],
];
